import { render } from "./UploadBanner.vue?vue&type=template&id=41c394cc"
import script from "./UploadBanner.vue?vue&type=script&lang=js"
export * from "./UploadBanner.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proj\\Apps\\takht-jamshid\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__